interface SpinnerProps {
  /** Diameter in px. Default 24. */
  size?: number
  className?: string
}

export function Spinner({ size = 24, className }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={className ? `scc-spinner ${className}` : 'scc-spinner'}
      style={{ width: size, height: size, borderWidth: Math.max(2, Math.round(size / 12)) }}
    />
  )
}
